import React from 'react';
import clsx from 'clsx';
import Button from '../button';
import styles from './index.module.scss';

export default function Loader(props) {
  const { backText, nextText, onBackClick, onNextClick } = props;
  return (
    <div className={clsx(styles.container, 'button-container')}>
      <Button text={backText} onClick={() => onBackClick()} />
      <Button active text={nextText} onClick={() => onNextClick()} />
    </div>
  );
}
